import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from "react-select";
import { optionSelector } from "../../config/apiSPA.js";
const parameter = { id: "", val: "", edit: "" };

function ModalEditSelect({ show, onHide, submitClick, data = {} }) {
  const attr = {
    title: data.title ?? "Edit Value",
    text: data.text ?? "Please edit as you wish :)",
    data: data.data ?? { id: "", val: "", edit: "" },
  };

  const [val, setVal] = useState(attr.data);
  const [option, setOption] = useState([]);
  const getOption = () => {
    optionSelector(`/${attr.data.edit}`).then((res) => setOption(res));
  };
  const handleChange = (e) => {
    setVal({ id: attr.data.id, val: e.value, edit: attr.data.edit });
  };

  useEffect(() => {
    if (!show) return;
    getOption();
  }, [show, data]);
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setVal(parameter);
          onHide();
        }}
      >
        <ModalHeader closeButton>
          <h5 className="modal-title">{attr.title}</h5>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Select onChange={(e) => handleChange(e)} options={option} isSearchable classNamePrefix="react-select" />
          </div>
          <div className="alert bg-inverse bg-opacity-15">{attr.text}</div>
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={() => submitClick(val)} className={val.val ? "btn btn-outline-theme" : "btn btn-outline-theme disabled"}>
            Save changes
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalEditSelect;
